// extracted by mini-css-extract-plugin
export var contentBody = "_d1-9";
export var headerImage = "_d1-2";
export var imageButton = "_d1-7";
export var imageButtonIcon = "_d1-8";
export var imageHeader = "_d1-4";
export var imageHeaderText = "_d1-5";
export var imageOverlay = "_d1-3";
export var imageTitle = "_d1-6";
export var imageWrapper = "_d1-1";
export var taskList = "_d1-a";
export var widget = "_d1-0";